// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body-image-container[data-v-42268eca]{width:35%;max-width:35%}.body-image-container img[data-v-42268eca]{width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
